import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import './index.css';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import React, { useEffect, Fragment, useRef } from 'react';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import Footer from '@clearscore/shared.website-footer';
import initialiseTrackingCookies from '@clearscore-group/lib.helpers.initialise-tracking-cookies';
import { Navigation } from '@clearscore/shared.website-navigation';
import { QueryClient, QueryClientProvider } from 'react-query';
import WebsiteAppDownloadBanner from '@clearscore/shared.website-app-download-banner';
import useLanguage from '@clearscore-group/lib.hooks.use-language';
import { getSessionToken } from '@clearscore-group/lib.helpers.session';
import { getVisitedSiteCookie } from '@clearscore-group/lib.helpers.cookies';
import Link from 'gatsby-link';
import Text from '@clearscore/ui.rainbow.text';
import { selectors, actions } from '@clearscore-group/lib.redux.cookie-policy';
import Notification from '@clearscore/ui.rainbow.notification';
import { EN_GB } from '@clearscore-group/lib.config.i18n';
import useWesbiteTracking from '@clearscore-group/lib.hooks.use-website-tracking';
function createCommonjsModule(fn) {
  var module = {
    exports: {}
  };
  return fn(module, module.exports), module.exports;
}
var devtools = createCommonjsModule(function (module) {
  {
    module.exports = {
      ReactQueryDevtools: function ReactQueryDevtools() {
        return null;
      },
      ReactQueryDevtoolsPanel: function ReactQueryDevtoolsPanel() {
        return null;
      }
    };
  }
});
var styles$3 = {
  "component": "component--wdkYC",
  "wrapper": "wrapper--7lARl",
  "items": "items--MD8Nr",
  "item": "item--suNeH",
  "activeUrl": "activeUrl--BNgQx"
};
var sortCategoriesRule = function sortCategoriesRule(a, b) {
  if (a.categoryNavPosition <= b.categoryNavPosition) {
    return -1;
  }
  if (a.categoryNavPosition > b.categoryNavPosition) {
    return 1;
  }
  return 0;
};
var SubNav = function SubNav(_ref) {
  var _ref$categories = _ref.categories,
    _categories = _ref$categories === void 0 ? [] : _ref$categories;
  var subNavLinks = _categories.sort(sortCategoriesRule).map(function (category) {
    return {
      url: category.categoryUrl,
      label: category.navTitle
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: styles$3.component
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3.items
  }, subNavLinks.map(function (_ref2) {
    var url = _ref2.url,
      label = _ref2.label;
    return /*#__PURE__*/React.createElement(Link, {
      key: url,
      className: styles$3.item,
      to: url,
      activeClassName: styles$3.activeUrl
    }, /*#__PURE__*/React.createElement(Text.Link1, null, label));
  }))));
};
var styles$2 = {
  "cookieNotice": "cookieNotice--uUU85",
  "link": "link--N0Hxu"
};
var CookiePolicy = function CookiePolicy(_ref3) {
  var enabled = _ref3.enabled,
    language = _ref3.language,
    moreInfoLinkUrl = _ref3.moreInfoLinkUrl;
  var dispatch = useDispatch();
  var isCookiePolicyAccepted = useSelector(selectors.getCookiePolicyAccepted);
  var acceptCookiePolicy = function acceptCookiePolicy() {
    return dispatch(actions.acceptCookiePolicy());
  };
  var showCookiePolicy = enabled && !isCookiePolicyAccepted;
  return showCookiePolicy ? /*#__PURE__*/React.createElement("div", {
    className: styles$2.cookieNotice,
    "data-qa": "cookie-policy"
  }, /*#__PURE__*/React.createElement(Notification, {
    ctaText: language.cta,
    ctaHandler: acceptCookiePolicy,
    isDismissible: false,
    isNewTab: true
  }, /*#__PURE__*/React.createElement(Text.Body2, null, language.information), /*#__PURE__*/React.createElement("span", {
    className: styles$2.link
  }, /*#__PURE__*/React.createElement(Text.Link, {
    isNewTab: true,
    href: moreInfoLinkUrl,
    theme: Text.Link.themes.LIGHT
  }, language.moreInfoLink)))) : null;
};
var styles$1 = {
  "contentGrid": "contentGrid--R0DvK",
  "grid": "grid--zAD70"
};
var Container = function Container(_ref4) {
  var _cx;
  var Tag = _ref4.tag,
    children = _ref4.children,
    isContentGrid = _ref4.isContentGrid;
  return /*#__PURE__*/React.createElement(Tag, {
    className: cx((_cx = {}, _defineProperty(_cx, styles$1.contentGrid, isContentGrid), _defineProperty(_cx, styles$1.grid, !isContentGrid), _cx))
  }, children);
};
Container.defaultProps = {
  tag: 'div',
  isContentGrid: false
};
var lang = _defineProperty({}, EN_GB, {
  appDownloadBannerText: {
    title: 'ClearScore - Credit Score',
    description: 'Track Score & Find Offers',
    ctaText: 'Download the app'
  }
});
var styles = {
  "nav": "nav--i0w-r",
  "pullUpContent": "pullUpContent--GD4Tp",
  "navScrollRef": "navScrollRef--7C6tu"
};

/* eslint-disable camelcase */
var MARKETING_CAMPAIGN_EVENT = 'fe_marketing_campaign_source';
var FIRST_TIME_VISIT_EVENT = 'fe_new_prospect_visited';
var useWebsiteTracking = function useWebsiteTracking() {
  var track = useWesbiteTracking();
  return {
    onFirstTimeVisit: function onFirstTimeVisit(userIdentity) {
      return track({
        name: FIRST_TIME_VISIT_EVENT,
        props: {
          CS_VISITED_SITE_COOKIE: userIdentity
        }
      });
    },
    onMarketingCampaignVisit: function onMarketingCampaignVisit(_ref5) {
      var utm_source = _ref5.utm_source,
        utm_medium = _ref5.utm_medium,
        utm_campaign = _ref5.utm_campaign,
        utm_term = _ref5.utm_term,
        utm_content = _ref5.utm_content;
      return track({
        name: MARKETING_CAMPAIGN_EVENT,
        props: {
          campaign_source: utm_source,
          campaign_medium: utm_medium,
          campaign_name: utm_campaign,
          campaign_term: utm_term,
          campaign_content: utm_content
        }
      });
    }
  };
};

// These do not need to live in market-config at the moment as app store links and tracking are global
var PLAY_STORE_LINK = 'https://clearscore.app.link/I1GDdOKRpib';
var IOS_STORE_LINK = 'https://clearscore.app.link/To3UOAxRpib';
var queryClient = new QueryClient();
var Grid = function Grid(_ref6) {
  var children = _ref6.children,
    tag = _ref6.tag,
    isContentGrid = _ref6.isContentGrid,
    dataLayout = _ref6.dataLayout;
  return /*#__PURE__*/React.createElement(Container, {
    tag: tag,
    "data-layout": dataLayout,
    isContentGrid: isContentGrid
  }, children);
};

/**
 * EXPERIMENT: Growth Alpha
 * This el is required for a banner provided via branch Journeys
 * and must be rendered beneath nav els to avoid overlap
 * Ticket: CS-96349
 */
var BranchBanner = function BranchBanner() {
  return /*#__PURE__*/React.createElement("div", {
    "data-id": "branch-experiment",
    className: "branch-journeys-top"
  });
};
var ContentGrid = function ContentGrid(_ref7) {
  var children = _ref7.children;
  return /*#__PURE__*/React.createElement(Grid, {
    isContentGrid: true
  }, children);
};
var TemplateNav = function TemplateNav(_ref8) {
  var pullUpContent = _ref8.pullUpContent,
    hasSubNav = _ref8.hasSubNav,
    categories = _ref8.categories,
    navigationConfig = _ref8.navigationConfig,
    hasAppDownloadBanner = _ref8.hasAppDownloadBanner;
  var scrollRef = useRef(null);
  var _useLanguage = useLanguage(lang),
    appDownloadBannerText = _useLanguage.appDownloadBannerText;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.nav, _defineProperty({}, styles.pullUpContent, pullUpContent && !hasSubNav))
  }, /*#__PURE__*/React.createElement(BranchBanner, null), hasAppDownloadBanner ? /*#__PURE__*/React.createElement(WebsiteAppDownloadBanner, {
    hasBorderBottom: true,
    text: appDownloadBannerText,
    playStoreLink: PLAY_STORE_LINK,
    iosStoreLink: IOS_STORE_LINK
  }) : null, /*#__PURE__*/React.createElement(Navigation, {
    config: navigationConfig,
    relativePosition: true,
    scrollRef: scrollRef
  })), /*#__PURE__*/React.createElement("span", {
    ref: scrollRef,
    className: styles.navScrollRef
  }), hasSubNav ? /*#__PURE__*/React.createElement(SubNav, {
    categories: categories
  }) : null);
};
function setHotjarIdentity() {
  // @ts-expect-error - hj is a global variable
  if (typeof window !== 'undefined' && window.hj) {
    var token = getSessionToken();
    var userData = token ? JSON.parse(atob(token.split('.')[1])) : {};
    var userID = userData.sub;
    var CS_VISITED_SITE_COOKIE = getVisitedSiteCookie();
    // @ts-expect-error - hj is a global variable
    window.hj('identify', userID, {
      CS_VISITED_SITE_COOKIE: CS_VISITED_SITE_COOKIE
    });
  }
}

// TODO: remove this when we have a better way to handle this CS-91626
function waitForHJ() {
  var attemptsLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;
  return new Promise(function (resolve) {
    var hjRetryTimeout = setTimeout(function () {
      // @ts-expect-error - hj is a global variable
      if (typeof window !== 'undefined' && window.hj) {
        clearTimeout(hjRetryTimeout);
        setHotjarIdentity();
        resolve();
      }
      if (attemptsLeft > 1) {
        waitForHJ(attemptsLeft - 1);
      } else {
        resolve();
      }
    }, 1000);
  });
}
var Template = function Template(_ref9) {
  var appStoreConfig = _ref9.appStoreConfig,
    cookiePolicyConfig = _ref9.cookiePolicyConfig,
    children = _ref9.children,
    _ref9$pullUpContent = _ref9.pullUpContent,
    _pullUpContent = _ref9$pullUpContent === void 0 ? false : _ref9$pullUpContent,
    _ref9$isGrid = _ref9.isGrid,
    _isGrid = _ref9$isGrid === void 0 ? true : _ref9$isGrid,
    _ref9$hasSubNav = _ref9.hasSubNav,
    _hasSubNav = _ref9$hasSubNav === void 0 ? false : _ref9$hasSubNav,
    _ref9$categories = _ref9.categories,
    _categories = _ref9$categories === void 0 ? [] : _ref9$categories,
    navigationConfig = _ref9.navigationConfig,
    _ref9$shouldHideNav = _ref9.shouldHideNav,
    _shouldHideNav = _ref9$shouldHideNav === void 0 ? false : _ref9$shouldHideNav,
    _ref9$shouldHideFoote = _ref9.shouldHideFooter,
    _shouldHideFooter = _ref9$shouldHideFoote === void 0 ? false : _ref9$shouldHideFoote,
    _ref9$hasAppDownloadB = _ref9.hasAppDownloadBanner,
    _hasAppDownloadBanner = _ref9$hasAppDownloadB === void 0 ? false : _ref9$hasAppDownloadB;
  var dispatch = useDispatch();
  var _useWebsiteTracking = useWebsiteTracking(),
    onFirstTimeVisit = _useWebsiteTracking.onFirstTimeVisit,
    onMarketingCampaignVisit = _useWebsiteTracking.onMarketingCampaignVisit;
  useEffect(function () {
    initialiseTrackingCookies({
      dispatch: dispatch
    }, null, {
      onFirstTimeVisit: onFirstTimeVisit,
      onMarketingCampaignVisit: onMarketingCampaignVisit
    });
    waitForHJ();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React.createElement(devtools.ReactQueryDevtools, {
    initialIsOpen: false
  }), /*#__PURE__*/React.createElement(Fragment, null, !_shouldHideNav && /*#__PURE__*/React.createElement(TemplateNav, {
    pullUpContent: _pullUpContent,
    hasSubNav: _hasSubNav,
    categories: _categories,
    navigationConfig: navigationConfig,
    hasAppDownloadBanner: _hasAppDownloadBanner
  }), _isGrid ? /*#__PURE__*/React.createElement(Grid, null, children) : children, !_shouldHideFooter && /*#__PURE__*/React.createElement(Footer, {
    appStoreConfig: appStoreConfig
  }), /*#__PURE__*/React.createElement(CookiePolicy, _objectSpread({}, cookiePolicyConfig))));
};
Template.Nav = TemplateNav;
Template.Grid = Grid;
Template.ContentGrid = ContentGrid;
Template.Footer = Footer;
Template.CookiePolicy = CookiePolicy;
export default Template;